export function authHeader(file = false) {
  // return authorization header with jwt token
  let user = JSON.parse(localStorage.getItem('user'));

  let unit = "";

  if(user.data.unitID)
    unit = 'unitID ' +  user.data.unitID;

  if (user && user.token) {
    if(file)
      return { 'Accept': 'application/json', 'Authorization':  unit + ' Bearer ' + user.token ,'Content-Type': 'multipart/form-data'};
    else
      return { 'Accept': 'application/json', 'Authorization': unit + ' Bearer ' + user.token };
  } else {
    return {};
  }
}



// WEBPACK FOOTER //
// ./src/_helpers/auth-header.js